/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import EndorsementWeb from '../visuals/endorsementweb-visuals/EndorsementWeb';
import { theme } from '../styles/theme';
import WaterPlot from '../visuals/redlining-charts/scatterplots/waterPlot';
import ChemPlot from '../visuals/redlining-charts/scatterplots/chemPlot';
import HealthPlot from '../visuals/redlining-charts/scatterplots/healthPlot';
import EconPlot from '../visuals/redlining-charts/scatterplots/econPlot';
import RedlineMap from '../visuals/redlining-charts/map-materials/map';
import GuideMap from '../visuals/guide-visuals/guideMap';
import HateBar from '../visuals/hate-charts/hateBar';
import HateLine from '../visuals/hate-charts/hateLine';
import LunchChart from '../visuals/rent-shelter-visuals/berkeleyAlamedaLunch';
import RentChart from '../visuals/rent-shelter-visuals/berkeleyAlamedaRent';
import BerkeleyShelterChart from '../visuals/rent-shelter-visuals/berkeleyShelter';
import AlamedaShelterChart from '../visuals/rent-shelter-visuals/alamedaShelter';
import BUSDBlackEnrollment from '../visuals/exodus-visuals/BlackEnrollmentBUSD';
import DistrictMap from '../visuals/exodus-visuals/district-map-materials/districtMap';
import BlackPopulationCensus from '../visuals/exodus-visuals/BlackPopulationCensus';
import GymTotals from '../visuals/gym-pac-12-visuals/gymTotals';
import GymVault from '../visuals/gym-pac-12-visuals/gymVault';
import GymBars from '../visuals/gym-pac-12-visuals/gymBars';
import GymBeam from '../visuals/gym-pac-12-visuals/gymBeam';
import GymFloor from '../visuals/gym-pac-12-visuals/gymFloor';
import Timeline1921 from '../visuals/1921-visuals/1921Timeline';
import STEMEnrollmentLine from '../visuals/STEM-visuals/STEMLine';
import TurnoverMap from '../visuals/turnover-visuals/turnoverMap';
import StudyAbroadMap from '../visuals/study-abroad-visuals/studyAbroadMap';
import ArtifactsBarChart from '../visuals/artifacts-visuals/artifactsBarChart';
import ArtifactsPieChart from '../visuals/artifacts-visuals/artifactsPieChart';
import HSILineChart from '../visuals/HSI-visuals/HSILineChart';
import SubscriberLineChart from '../visuals/reddit-visuals/subscriberCount';
import DailyCommentLineChart from '../visuals/reddit-visuals/dailyCommentCount';
import PostsPerHourBarChart from '../visuals/reddit-visuals/postsPerHourBarChart';
import PostsPerDayBarChart from '../visuals/reddit-visuals/postsPerDayBarChart';
import PostsPerFlairBarChart from '../visuals/reddit-visuals/postsPerFlairBarChart';
import GapStackedBarChart from '../visuals/gap-visuals/gapStackedBarChart';
import ProposalsASE from '../visuals/bargaining-visuals/proposalsASE';
import ProposalsAR from '../visuals/bargaining-visuals/proposalsAR';
import ProposalsPostocs from '../visuals/bargaining-visuals/proposalsPostdocs';
import ProposalsSR from '../visuals/bargaining-visuals/proposalsSR';
import OptionWidthBarChart from '../visuals/telegraph-visuals/optionWidths';
import KutcherTimeline from '../visuals/kutcher-visuals/kutcherTimeline';
import UnionVoteBarChart from '../visuals/union-vote-visuals/unionVoteBarChart';
import TimeDoctorateBarChart from '../visuals/union-vote-visuals/timeDoctorateBarChart';
import UniversityRentMap from '../visuals/rent-map-visuals/universityRentMap';
import OptionWidthViz2 from '../visuals/telegraph-visuals/optionWidths2';
import WarnmeHistogram from '../visuals/warnme-visuals/warnmeHistogram';
import MarkerClusterMap from '../visuals/theft-visuals/bikeTheftMap';
import TheftsPerYearBarChart from '../visuals/theft-visuals/theftsPerYearBarChart';
import PopularTheftLocationsBarChart from '../visuals/theft-visuals/popularTheftLocationsBarChart';
import TheftsPerHourLineChart from '../visuals/theft-visuals/theftsPerHourLineChart';
import BikeTheftTips from '../visuals/theft-visuals/bikeTheftTips';
import InternalAuditBarChart from '../visuals/internal-audit-visuals/internalAuditBarChart';
import DepartmentBarChart from '../visuals/internal-audit-visuals/departmentBarChart';
import ExternalAuditBarChart from '../visuals/external-audit-visuals/externalAuditBarChart';
import AgeBarChart from '../visuals/opioids-visuals/AgeBarChart';
import TestStripMap from '../visuals/opioids-visuals/TestStripMap';
import RatesMap from '../visuals/opioids-visuals/RatesMap/Choropleth';
import App from '../visuals/pac-12-finances-visuals/App';
import ConferenceMap from '../visuals/pac-12-finances-visuals/visuals/Map';
import ConferenceBarChart from '../visuals/pac-12-finances-visuals/visuals/ConferenceBarChart';
import DebtBarChart from '../visuals/pac-12-finances-visuals/visuals/DebtBarChart';
import AreaCharts from '../visuals/pac-12-finances-visuals/visuals/AreaCharts';
import DropdownBudgetOverTime from '../visuals/pac-12-finances-visuals/visuals/DropdownBudgetOverTime';
import ClassDayMap from '../visuals/campus-busyness-visuals/visuals/ClassDayMap';
import ClassEnrollmentLineChart from '../visuals/campus-busyness-visuals/visuals/ClassEnrollmentLineChart';
import ClassSizeBarChart from '../visuals/campus-busyness-visuals/visuals/ClassSizeBarChart';
import TopEditsPerSchool from '../visuals/wikiedits-visuals/top_edits_per_school';
import EditsOverTime from '../visuals/wikiedits-visuals/edits_over_time';
import Wikidiff from '../visuals/wikiedits-visuals/wikidiff';
import EditsPerSchool from '../visuals/wikiedits-visuals/edits_per_school';
import SemanticMap from '../visuals/wikiedits-visuals/semantic_map';
import Wikimage from '../visuals/wikiedits-visuals/wikimage';
import DatawrapperChart from './dataWrapper';
import ASUCFunding from '../visuals/club-finances-visuals/asucFunding';
import SexyMap from '../visuals/too-sexy-visuals/map';
import { BugVideoScroller } from '../visuals/bug-bodycam-visuals/bug-video-scroller';
import { BugVideoExpander } from '../visuals/bug-bodycam-visuals/bug-video-expander';
import { DCVideoPlayer } from '../visuals/bug-bodycam-visuals/components/dc-video-player';
import { TextImage } from '../visuals/bug-bodycam-visuals/components/text-image';
import MichVis from '../visuals/dining-visuals/MichVis';
import NutritionVis from '../visuals/dining-visuals/NutritionVis';
import ScrollyNew from '../visuals/dining-visuals/ScrollyNew';
import HackVisuals from '../visuals/shiny-hunters-visuals/hack_visuals';
import BayPassCalculator from '../visuals/clipper-visuals/baypasscalculator';
import CandidateFinanceVisuals from '../visuals/candidate-visuals/finance_visuals';
import TransferVisual from '../visuals/transfers-visuals/TransferVisual';
import AdmissionsDots from '../visuals/transfers-visuals/AdmissionsDots';
import CollegePathways from '../visuals/transfers-visuals/CollegePathways';
import AcTransitStory from '../visuals/ac-transit-visuals/AcTransitStory';
import ThirdPlaceMap from '../visuals/thirdplace-visuals/map';
import NobelScrolly, { NobelNote } from '../visuals/nobel-visuals/NobelScrolly';
import RentOMeterStory from '../visuals/rent-o-meter-visuals/RentOMeterStory';
import CleryStory, { CleryScrolly } from '../visuals/clery-visuals/CleryStory';
import MoneyFlowMap from '../visuals/money-flow-visuals/MoneyFlowMap';
import PacBubbles from '../visuals/money-flow-visuals/PacBubbles';
import DonorSearch from '../visuals/money-flow-visuals/DonorSearch';
import Topics from '../visuals/citybloc-visuals/Topics';
import Dissents from '../visuals/citybloc-visuals/Dissents';
import Agreement from '../visuals/citybloc-visuals/Agreement';
import BlocUnity from '../visuals/citybloc-visuals/BlocUnity';
import BlocMoves from '../visuals/citybloc-visuals/BlocMoves';
import SplitSides from '../visuals/citybloc-visuals/SplitSides';
import MotionExplorer from '../visuals/citybloc-visuals/MotionExplorer';
/*
To avoid using exact paths in MDX files, import your components here
and add them to the shortcodes list to be globally accessible.ß
To use a component in MDX, simply type <MyComponent />
Note: MDXProvider doesn't like parsing individual HTML elements followed
by an array of React components, so we must include them in the same array.
*/

const shortcodes = {
  EndorsementWeb,
  // style MDX files for any html element here!!
  a: (props) => (
    <a {...props} style={{ textDecoration: 'underline', color: theme.palette.black }} />), // styles MDX hyperlinks
  p: (props) => <p {...props} style={{ color: theme.palette.black }} />,
  img: (props) => <img {...props} style={{ display: 'flex', flexDirection: 'column' }} />,
  // cap: (props) => <cap {...props} style={{ text:  }} />,
  WaterPlot,
  ChemPlot,
  HealthPlot,
  EconPlot,
  RedlineMap,
  GuideMap,
  HateBar,
  HateLine,
  LunchChart,
  RentChart,
  BerkeleyShelterChart,
  AlamedaShelterChart,
  BUSDBlackEnrollment,
  DistrictMap,
  BlackPopulationCensus,
  GymTotals,
  GymVault,
  GymBars,
  GymBeam,
  GymFloor,
  Timeline1921,
  STEMEnrollmentLine,
  TurnoverMap,
  StudyAbroadMap,
  ArtifactsBarChart,
  ArtifactsPieChart,
  HSILineChart,
  SubscriberLineChart,
  DailyCommentLineChart,
  PostsPerHourBarChart,
  PostsPerDayBarChart,
  PostsPerFlairBarChart,
  GapStackedBarChart,
  ProposalsASE,
  ProposalsAR,
  ProposalsSR,
  ProposalsPostocs,
  OptionWidthBarChart,
  KutcherTimeline,
  UnionVoteBarChart,
  TimeDoctorateBarChart,
  UniversityRentMap,
  OptionWidthViz2,
  WarnmeHistogram,
  MarkerClusterMap,
  TheftsPerYearBarChart,
  PopularTheftLocationsBarChart,
  TheftsPerHourLineChart,
  BikeTheftTips,
  InternalAuditBarChart,
  DepartmentBarChart,
  ExternalAuditBarChart,
  AgeBarChart,
  TestStripMap,
  RatesMap,
  App,
  ConferenceMap,
  ConferenceBarChart,
  DebtBarChart,
  AreaCharts,
  DropdownBudgetOverTime,
  ClassDayMap,
  ClassEnrollmentLineChart,
  ClassSizeBarChart,
  TopEditsPerSchool,
  EditsOverTime,
  Wikidiff,
  EditsPerSchool,
  SemanticMap,
  Wikimage,
  DatawrapperChart,
  ASUCFunding,
  SexyMap,
  BugVideoScroller,
  BugVideoExpander,
  DCVideoPlayer,
  TextImage,
  michVis: MichVis,
  nutritionVis: NutritionVis,
  scrollyNew: ScrollyNew,
  HackVisuals,
  BayPassCalculator,
  CandidateFinanceVisuals,
  TransferVisual,
  AdmissionsDots,
  CollegePathways,
  AcTransitStory,
  ThirdPlaceMap,
  NobelScrolly,
  NobelNote,
  RentOMeterStory,
  CleryStory,
  CleryScrolly,
  MoneyFlowMap,
  PacBubbles,
  DonorSearch,
  Topics,
  Dissents,
  Agreement,
  BlocUnity,
  BlocMoves,
  SplitSides,
  MotionExplorer,
};

export default function Layout({ children }) {
  return (
    <MDXProvider
      components={shortcodes}
    >
      {children}
    </MDXProvider>
  );
}
